import { formatKeyForInput } from '../pages/create-template/extensions/fieldTokenEditorUtils';
import { normalizeTemplateName } from '../pages/create-template/utils/templateNameUtils';

const EMPTY_EDITOR_DOCUMENT = { type: 'doc', content: [{ type: 'paragraph' }] };

function normalizeEditorDocument(raw) {
  if (raw && typeof raw === 'object' && raw.type === 'doc' && Array.isArray(raw.content)) {
    return raw;
  }
  return EMPTY_EDITOR_DOCUMENT;
}

/**
 * @param {{
 *   id: string;
 *   name: string;
 *   fields: Array<{ key: string; fieldName?: string; type: string; obrigatorio?: boolean }>;
 *   content?: object;
 * }} params
 */
export function buildTemplateSavePayload({ id, name, fields, content }) {
  return {
    id: String(id ?? '').trim(),
    name: normalizeTemplateName(name),
    fields: (fields ?? []).map((field) => ({
      key: formatKeyForInput(field.key),
      name: String(field.fieldName ?? '').trim(),
      type: field.type,
      required: Boolean(field.obrigatorio),
    })),
    content: normalizeEditorDocument(content),
  };
}
